// const agenet = checkUserAgent()

import axios from 'axios'
import qs from 'qs'
export default {
  BASE_URL: 'https://activity.sznews.com/front/luohu_question_front/index.php?s=index',
  URL_UserInfo: '/User/getAppUserInfo',
  // agenet: checkUserAgent(),

  testAxios() {
    const _this = this;
    axios({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: _this.BASE_URL + _this.URL_UserInfo,
      data: qs.stringify({data:str})

    }).then(res => {
      console.log('goLogin', res.data);
      localStorage.setItem("luoohutoken", res.data.code);
    }).catch(rej => {
      console.log('goLoginErr', rej);
    })
  },

  checkUserAgent() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 'android';
    } else {
      return 'pc';
    };
  },

  VerifyState() {
    console.log('VerifyState begin');
    const _this = this;
    try {
      if (agenet == 'ios') {

        _this.setupWebViewJavascriptBridge(function (bridge) {

          bridge.callHandler('getAppLogin', {
            'key': 'value'
          }, function responseCallback(responseData) {
            console.log("JS received response:", responseData);
            if (!responseData) {
              localStorage.setItem("luoohutoken", '');
              return false
            }
            responseData = JSON.parse(responseData);
            if (responseData.key == "1") {
              // _this.checkLogin();
              localStorage.setItem("luoohutoken", responseData);
            } else {
              localStorage.setItem("luoohutoken", '');
            }
          })
        });
      } else if (agenet == 'android') {
        var responseData = appJiaohu.getAppLogin();
        console.log('VerifyState', responseData);
        if (!responseData) {
          localStorage.setItem("luoohutoken", '');
          return false
        }
        responseData = JSON.parse(responseData);

        if (responseData.code == "1") {
          // _this.checkLogin();
          localStorage.setItem("luoohutoken", responseData);
        } else {
          localStorage.setItem("luoohutoken", '');
        }
      } else {
        localStorage.setItem("luoohutoken", '');
      }
    } catch (err) {
      console.log('VerifyState err', err);
      localStorage.setItem("luoohutoken", '');
    }

  },

  setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  },

  checkLogin() {
    const _this = this;

    if (agenet == 'ios') {
      _this.setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('getAppUserInfo', {
          'key': 'value'
        }, function responseCallback(responseData) {
          console.log("JS received response:", responseData);
          localStorage.setItem("luoohutoken", responseData);
          // _this.goLogin(responseData);
          // _this.initCredict(responseData)
        })
      });
    } else if (agenet == 'android') {
      var responseData = appJiaohu.getAppUserInfo('');
      console.log('checkLogin', responseData);
      localStorage.setItem("luoohutoken", responseData);
      // _this.goLogin(responseData);
      // _this.initCredict(responseData)
    } else {

    }
  },

  goLogin(str) {
    const _this = this;
    if (str == "" || str == null) {
      layer.msg("请获取有效信息");
      return false;
    }
    console.log('goLogin', str);
    axios({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: _this.BASE_URL + _this.URL_UserInfo,
      data: qs.stringify({data:str})

    }).then(res => {
      console.log('goLogin', res.data);
      localStorage.setItem("luoohutoken", res.data.code);
    }).catch(rej => {
      console.log('goLoginErr', rej);
    })

    // $.post(URL_UserInfo, {
    //   data: str
    // }, function (res) {
    //   console.log('goLogin', res);
    //   localStorage.setItem("luoohutoken", res.code);

    // });
  },

  setupEnv() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('lhapp/hdpage') > -1) {
      // app环境
      localStorage.setItem('env', 'app');
    } else {
      localStorage.setItem('env', 'outer');
    }
  }
}